import { observer } from 'mobx-react-lite'
import { ReactElement } from 'react'
import styled from 'styled-components'
import CloseIcon from '@mui/icons-material/Close'
import { I18n } from 'common'
import { defaultTheme } from '../../../theme'

interface HeaderProps {
  yearMakeModel: string
  engine: string
  title: string
  onClose: () => void
}

const DrawerHeader = observer((props: HeaderProps): ReactElement => {
  const { yearMakeModel, engine, title, onClose } = props
  return (
    <Header>
      <TitleHeader>
        <>
          <I18n name={title} />
          <StyledCloseIcon onClick={onClose} />
        </>
      </TitleHeader>
      <VehicleInfo>
        <VehicleYearMakeModel>{yearMakeModel}</VehicleYearMakeModel>
        <VehicleEngine>{engine}</VehicleEngine>
      </VehicleInfo>
    </Header>
  )
})
export default DrawerHeader

const Header = styled.div``

const VehicleInfo = styled.div`
  display: flex;
  font-family: Roboto;
  font-style: normal;
  font-size: 18px;
  line-height: 24px;
  text-transform: uppercase;
`

const Bold = styled.span`
  font-weight: 700;
`

const VehicleYearMakeModel = styled(Bold)``

const VehicleEngine = styled.span`
  padding-left: 0.5rem;
`
const TitleHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: Oswald, serif;
  font-style: normal;
  font-size: 28px;
  font-weight: bold;
  line-height: 48px;
  color: ${defaultTheme.colors.almostBlack};
`

const StyledCloseIcon = styled(CloseIcon)`
  cursor: pointer;
`
